import script from "./vmsCustomAttributeManager.vue?vue&type=script&lang=js"
export * from "./vmsCustomAttributeManager.vue?vue&type=script&lang=js"

import "./vmsCustomAttributeManager.vue?vue&type=style&index=0&id=5ace3ddd&lang=css"
import "./vmsCustomAttributeManager.vue?vue&type=style&index=1&id=5ace3ddd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ace3ddd"]])

export default __exports__